export const editMutations = <const>{
	PRACOVNIK_SELECT_MAPPER: 'pracovnikSelectMapper',
	ZAKAZNIK_SELECT_MAPPER: 'zakaznikSelectMapper',
	POJISTOVNA_SELECT_MAPPER: 'poistovnaSelectMapper',
	LEASING_SELECT_MAPPER: 'leasingSelectMapper',
	VOZIDLO_PUJCOVNA_SELECT_MAPPER: 'vozidloPujcovnaSelectMapper',
};
